import React from 'react';
import { LatestNewsProvider } from '../context/LatestNewsContext';
import LatestNewsPaginatedFilterBar from './LatestNewsPaginatedFilterBar';
import LatestNewsPaginatedContent from './LatestNewsPaginatedContent';

import Articles from '../services/Articles';

export default function LatestNewsPaginated({ dir, id }) {
  const articles = new Articles();
  const data = articles.get(dir === 'rtl' ? 'ar' : 'en');

  return (
    <LatestNewsProvider id={id}>
      <LatestNewsPaginatedFilterBar dir={dir} />
      <LatestNewsPaginatedContent dir={dir} data={data} />
    </LatestNewsProvider>
  );
}
